module.exports = __webpack_public_path__ + "media/images/payments/googlewallet-dark-aa83ab33512f9c7afb3d6499891c7f93.svg";